(() => {
  const config = document.getElementById('mxpro-fitment-labels');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const ids = ['easysearch_field_28411', 'easysearch_field_28412', 'easysearch_field_28410'];
  const attached = new WeakSet();
  function attach(container) {
    if (attached.has(container)) return;
    if (!ids.every(id => container.querySelector(`[id="${id}"]`))) return;
    attached.add(container);
    const hint = document.createElement('p');
    hint.className = 'mxpro-fitment-hint';
    hint.setAttribute('aria-live', 'polite');
    container.append(hint);
    const fields = () => ids.map(id => container.querySelector(`[id="${id}"]`));
    const ready = () => fields().every(field => field && !field.disabled && field.value);
    const sync = () => {
      const button = container.querySelector('.easysearch-btn-search');
      const isReady = ready();
      if (button) {
        button.setAttribute('aria-disabled', String(!isReady));
        if (!isReady && button.hasAttribute('href')) button.removeAttribute('href');
      }
      const text = isReady ? labels.ready : labels.choose;
      if (hint.textContent !== text) hint.textContent = text;
    };
    container.addEventListener('change', () => { sync(); requestAnimationFrame(sync); });
    container.addEventListener('click', event => {
      const button = event.target.closest('.easysearch-btn-search');
      if (!button) return;
      if (ready()) {
        const [make, model, year] = fields().map(field => field.value);
        const href = button.getAttribute('href');
        let destination;
        try { destination = href && new URL(href, location.href); } catch (_) { return; }
        if (!destination || destination.origin !== location.origin || !/^[/](?:[a-z]{2}(?:-[a-z]{2})?[/])?collections[/][^/]+[/][^/]+[/]?$/.test(destination.pathname)) return;
        try { sessionStorage.setItem('mxpro-ymm-selection-v1', JSON.stringify({make, model, year, path: destination.pathname})); } catch (_) {}
        if (!button.hasAttribute('data-easysearch-action') && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          location.assign(destination.href);
        }
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      const missing = fields().find(field => field && !field.disabled && !field.value);
      if (missing) missing.focus();
      sync();
    }, true);
    new MutationObserver(sync).observe(container, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'href']});
    sync();
  }
  function discover(root) {
    if (root.nodeType !== 1) return;
    const parent = root.closest('.easysearch-container');
    if (parent) attach(parent);
    if (root.matches('.easysearch-container')) attach(root);
    root.querySelectorAll('.easysearch-container').forEach(attach);
  }
  discover(document.documentElement);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(discover))).observe(document.body, {childList: true, subtree: true});

  const panel = document.getElementById('mxpro-product-fitments');
  if (!panel) return;
  const data = JSON.parse(panel.querySelector('[data-fitment-data]').textContent);
  const variants = JSON.parse(panel.querySelector('[data-fitment-variants]').textContent);
  const query = panel.querySelector('input[type="search"]');
  const list = panel.querySelector('[data-fitment-list]');
  const count = panel.querySelector('[data-fitment-count]');
  const more = panel.querySelector('[data-fitment-more]');
  let limit = 30;
  let previousVariant = '';
  const normalize = value => String(value).toLocaleLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
  const displayNote = note => String(note || '')
    .replace(/\bNormal use\b/g, 'Normaal gebruik')
    .replace(/\bCompetition use\b/g, 'Wedstrijdgebruik')
    .replace(/\bModerate climate\b/g, 'Gematigd klimaat')
    .replace(/\bNormal\b/g, 'Normaal')
    .replace(/\bCapacity\b/g, 'Inhoud')
    .replace(/\bKilometerstand: -150\s?000km\b/g, 'Kilometerstand: tot 150.000 km')
    .replace(/; Fabrikant vermeldt \d{4} en later; hier afgebakend t\/m \d{4}\./g, '')
    .replace(/(\d)(ml)\b/g, '$1 $2');
  const displayModel = row => /\bFACTORY\b/i.test(row.note || '') && !/\bFACTORY\b/i.test(row.model)
    ? `${row.model} ${/Factory Replica/i.test(row.note) ? 'Factory Replica' : 'Factory'}` : row.model;
  function searchable(row) {
    const model = displayModel(row);
    // Preserve every qualifier while accepting common displacement word orders.
    const alias = model.replace(/^(\d{2,4})\s+([A-Z][A-Z-]*)\b/i, '$2 $1')
      .replace(/^([A-Z][A-Z-]*)\s+(2T|4T)\s*(\d{2,4})\b/i, '$1 $3 $2');
    return normalize(`${row.make} ${model} ${alias} ${row.note || ''} ${displayNote(row.note)}`);
  }
  function selected() {
    return document.querySelector('.c-product__summary form[action*="/cart/add"] [name="id"]')?.value || new URL(location.href).searchParams.get('variant') || panel.dataset.initialVariant;
  }
  function matchingRows() {
    const id = selected();
    const current = variants.find(variant => String(variant.id) === id);
    const source = data.variants.find(variant => variant.id.split('/').pop() === id && current && variant.sku === current.sku);
    if (!source) return [];
    const tokens = query.value.trim().split(/\s+/).filter(Boolean);
    return source.fitments.filter(row => tokens.every(token => /^\d{4}$/.test(token)
      ? Number(token) >= row.year_from && Number(token) <= row.year_to
      : searchable(row).includes(normalize(token))));
  }
  function render() {
    const rows = matchingRows();
    list.replaceChildren();
    rows.slice(0, limit).forEach(row => {
      const li = document.createElement('li');
      const name = document.createElement('strong');
      name.textContent = `${row.make} ${displayModel(row)}`;
      const years = document.createElement('span');
      years.textContent = row.year_from === row.year_to ? String(row.year_from) : `${row.year_from}–${row.year_to}`;
      li.append(name, years);
      if (row.note) { const note = document.createElement('small'); note.textContent = displayNote(row.note); li.append(note); }
      list.append(li);
    });
    count.textContent = rows.length ? (rows.length === 1 ? labels.countOne : labels.count).replace('{count}', rows.length) : labels.noMatch;
    more.hidden = rows.length <= limit;
  }
  query.addEventListener('input', () => { limit = 30; render(); });
  more.addEventListener('click', () => { limit += 30; render(); });
  document.addEventListener('change', () => requestAnimationFrame(() => {
    if (selected() !== previousVariant) { previousVariant = selected(); limit = 30; render(); }
  }));
  // The theme also changes the variant ID without emitting a native change event.
  const timer = setInterval(() => {
    if (!panel.isConnected) { clearInterval(timer); return; }
    if (selected() !== previousVariant) { previousVariant = selected(); limit = 30; render(); }
  }, 500);
  previousVariant = selected();
  render();
})();
